import { ff } from '@atlassian/jira-feature-flagging';
import { createAri } from '@atlassian/jira-platform-ari';
// eslint-disable-next-line jira/restricted/@atlassian+jira-relay-utils
import { createRelayResource } from '@atlassian/jira-relay-utils';

import TOOLCHAIN_OVERVIEW_QUERY, {
	type main_softwareProjectSettingsDevopsConnections_ToolchainOverviewQuery as ToolchainOverviewQuery,
} from '@atlassian/jira-relay/src/__generated__/main_softwareProjectSettingsDevopsConnections_ToolchainOverviewQuery.graphql';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils';

const RESOURCE_TYPE_DEVOPS_CONNECTIONS = 'RESOURCE_TYPE_DEVOPS_CONNECTIONS';

const toolchainOverviewResource = resourceWithCondition2(
	() => !ff('simplified-toolchain-page_g5582'),
	createRelayResource<ToolchainOverviewQuery>({
		type: RESOURCE_TYPE_DEVOPS_CONNECTIONS,
		isBrowserOnly: true,
		getQuery: (routerContext, { tenantContext }) => {
			const { query } = routerContext;
			return {
				parameters: TOOLCHAIN_OVERVIEW_QUERY,
				variables: {
					siteAri: createAri({
						resourceOwner: 'jira',
						resourceType: 'site',
						resourceId: tenantContext.cloudId,
					}),
					projectId: createAri({
						resourceOwner: 'jira',
						cloudId: tenantContext.cloudId,
						resourceType: 'project',
						resourceId: String(query.projectId),
					}),
					cloudId: tenantContext.cloudId,
					groupId: query.groupId,
					devOpsToolRelationshipsFilter: query.groupId
						? {
								hasPropertyEqualTo: {
									key: 'groupId',
									value: query.groupId,
								},
							}
						: null,
				},
				options: { fetchPolicy: 'store-and-network' },
			};
		},
	}),
);

export const devopsConnectionsResource = toolchainOverviewResource;
